import { EventApi } from '@fullcalendar/core';

export function getEventTab(event: EventApi, projectId: string): 'pause' | 'range' | 'stage' {
  if (event.extendedProps.type === 'stage') return 'stage';
  if (event.id === `pause-${projectId}`) return 'pause';
  return 'range';
}
